<template>
  <div class="content">
    <div class="content-main">
      <p class="content-title">红娘短信管理</p>
      <div class="content-input">
        <div class="content-input-item">
          <label>状态：</label>
          <el-select v-model="state" placeholder="Select" style="width: 6.4em">
            <el-option v-for="item in stateArray" :key="item.value" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
        </div>
        <div class="content-input-item">
          <label>短信涞源：</label>
          <el-select v-model="smsSource" placeholder="Select" style="width: 8em">
            <el-option v-for="item in smsSourceArray" :key="item.value" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
        </div>
        <div class="content-input-item">
          <SearchComponents :searchTypeList="searchTypeList" :searchType="searchType"  :searchValue="searchValue" @searchType="getSearchType($event)" @searchValue="getSearchValue($event)" />
        </div>
        <div class="content-input-item">
          <ElButtons type="primary" icon="search" v-loading="searchLoading" :disable="searchLoading" @click="getPage(true)"> 查询 </ElButtons>
          <ElButtons icon="RefreshLeft" @click="refreshParam"> 重置 </ElButtons>
        </div>
      </div>
    </div>
    <div class="content-main">
      <div class="content-button">
        <div>
          <el-button type="primary" @click="editMsgDialog(-1)">新建</el-button>
        </div>
        <BtnGroup :tableRef="$refs.multipleTableRef" :colList="colList" @colListChange="colListChange($event)" @refresh="getPage"></BtnGroup>
      </div>
      <div class="content-table">
        <el-table
            ref="multipleTableRef"
            :data="pageDataList"
            style="width: 100%"
            v-loading="listLoading"
            border
        >
          <el-table-column property="city" label="城市" v-if="checkColList.indexOf('城市') > -1" >
            <template #default="scope">
              {{ scope.row.city == -1?'不限':scope.row.city}}
            </template>
          </el-table-column>
          <el-table-column property="url" label="URL" v-if="checkColList.indexOf('URL') > -1"></el-table-column>
          <el-table-column property="nickname" label="昵称" v-if="checkColList.indexOf('昵称') > -1"></el-table-column>
          <el-table-column property="" label="头像" v-if="checkColList.indexOf('头像') > -1">
            <template #default="scope">
              <el-image style="width: 80px; height: 80px" :src="scope.row.avatar"><template #error><div class="el-img-error">暂无图片</div></template></el-image>
            </template>
          </el-table-column>
          <el-table-column property="wechatId" label="客服微信" v-if="checkColList.indexOf('客服微信') > -1"></el-table-column>
          <el-table-column property="smsCode" label="短信模板ID" v-if="checkColList.indexOf('短信模板ID') > -1"></el-table-column>
          <el-table-column property="" label="状态" v-if="checkColList.indexOf('状态') > -1">
            <template #default="scope">
              {{scope.row.state == 0?'无效':scope.row.state == 1?'有效':''}}
            </template>
          </el-table-column>
          <el-table-column property="" label="操作" v-if="checkColList.indexOf('操作') > -1">
            <template #default="scope">
              <el-space wrap>
                <el-button size="small" @click="editMsgDialog(scope.$index,scope.row)" type="primary">编辑</el-button>
                <el-button size="small" v-loading="scope.row['updateLoading']" type="success" v-if="scope.row.state == 0" @click="updateState(scope.$index, scope.row, 1)">设为有效</el-button>
                <el-button size="small" v-loading="scope.row['updateLoading']" type="warning" v-if="scope.row.state == 1" @click="updateState(scope.$index, scope.row, 0)">设为无效</el-button>
              </el-space>
            </template>
          </el-table-column>
        </el-table>
        <el-pagination background layout="total, prev, pager, next, jumper" :total="totalRow" :page-size="pageSize" :current-page="currentPage" @current-change="handleCurrentChange">
        </el-pagination>
      </div>
    </div>
  </div>
</template>

<script>
// import BtnGroup from '../../components/BtnGroup'
import { getMatchmakerSmsPageList, updateMatchmakerSmsState } from '../../api/url'
import {getFormData, postFormData} from '../../api/api'
import Dialog from "@/assets/js/dialog";
import MatcherSmsDialog from "./components/MatcherSmsDialog";
import SearchComponents from "../../components/SearchComponents";

export default {
  name: "MatcherMsg",
  components: { SearchComponents },
  data() {
    return {

      stateArray: [
        {label: '不限', value: -1},
        {label: '无效', value: 0},
        {label: '有效', value: 1},
      ],
      state: -1,

      smsSourceArray: [
        {label: "赛邮短信", value: 1},
        // {label: "示远短信", value: 2}
      ],
      smsSource: 1,

      //搜索
      searchTypeList: [
        {label : '城市名称', value : 1},
      ],
      searchType: 1,
      searchValue: '',

      //刷新组
      colList: ['城市', 'URL', '昵称', '头像', '客服微信', '短信模板ID', '状态', '操作'],
      checkColList: [],

      pageDataList: [],
      currentPage: 1,
      totalRow: 0,
      pageSize: 20,

      searchLoading: false,
      listLoading: false,

    }
  },
  methods: {
    getSearchType(e) {
      this.searchType = e;
    },
    getSearchValue(e) {
      this.searchValue = e;
    },
    // 展示表格的列
    colListChange(val) {
      this.checkColList = val;
    },
    // 重置参数
    refreshParam() {
      this.searchValue = '';
      this.state = -1;
      this.smsSource = 1;
      this.getPage(true);
    },
    //分页
    handleCurrentChange(val) {
      this.currentPage = val;
      this.getPage();
    },

    getPage(reset) {
      if(isNaN(this.currentPage)) {
        this.$message({
          showClose: true,
          duration: 1000,
          message: '请提交正确的页码',
          type: 'warning'
        })
      } else {
        if(reset) {
          this.currentPage = 1;
        }
        this.searchLoading = true;
        this.listLoading = true;
        this.sendPageReq(this.getPageParam(this.currentPage));
      }
    },

    //页面参数
    getPageParam(page) {
      let param = {};
      param['pageNum'] = page;
      param['state'] = this.state;
      param['smsSource'] = this.smsSource;
      param['searchType'] = this.searchType;
      param['searchValue'] = this.searchValue;
      this.pageParam = param;
      return param;
    },
    // 发送页面列表请求
    sendPageReq(param) {
      getFormData(getMatchmakerSmsPageList, param).then((data) => {
        let {msg, code } = data;
        if(code == 200) {
          let result = data['data'];
          this.pageDataList = result['records'];
          this.totalRow = result['total'];
          this.pageSize = result['size'];
        }else{
          this.$message({
            showClose: true,
            duration: 1000,
            message: msg,
            type: 'warning'
          })
        }
        this.searchLoading = false;
        this.listLoading = false;
      })
          .catch(() => {
            this.searchLoading = false;
            this.listLoading = false;
          })
    },

    editMsgDialog(idx, row) {
      let _title = '';
      let smsForm = {}
      if (idx > -1) {
        _title = '编辑消息'
        smsForm = Object.assign({}, row);
      }else {
        _title = '新建消息'
      }
      Dialog.open({
        title: _title,
        component: MatcherSmsDialog,
        data: {
          smsForm: smsForm,
          ids: idx,
          width: '500px'
        },
        confirm: (result) => {
            this.getPage()
        }
      })
    },

    updateState(idx, row, state) {
      this.pageDataList[idx]['updateLoading'] = true;
      let param = {};
      param['id'] = row.id;
      param['state'] = state;
      postFormData(updateMatchmakerSmsState, param).then((data)=>{
        let {code, msg} = data;
        if (code == 200) {
          this.$message({
            showClose: true,
            duration: 1000,
            message: msg,
            type: 'success'
          })
          this.getPage()
        }else {
          this.$message({
            showClose: true,
            duration: 1000,
            message: msg,
            type: 'warning'
          })
        }
        this.pageDataList[idx]['updateLoading'] = false;
      }).catch(()=> {
        this.pageDataList[idx]['updateLoading'] = false;
      })
    }


  },
  mounted() {
    this.$nextTick(function() {
      this.checkColList = this.colList;
    })
    this.getPage();
  }
}
</script>

<style scoped>

</style>
